import { useEffect, useState } from 'react';
import Auth, { Session } from './screens/Auth';
import Chat from './screens/Chat';
import { setAuthToken, setOnUnauthorized } from './api';
import { clearVault } from './storage';

export default function App() {
  // baseSession: la sesión de la cuenta base (general). NUNCA cambia mientras
  // el usuario navega entre freqs — solo en logout.
  // activeSession: la sesión que se está usando ahora mismo. Igual a baseSession
  // cuando el usuario está en general; igual a una pseudo-sesión cuando está
  // dentro de una freq secreta.
  const [baseSession, setBaseSession] = useState<Session | null>(null);
  const [activeSession, setActiveSession] = useState<Session | null>(null);

  useEffect(() => {
    setOnUnauthorized(() => {
      try {
        for (let i = localStorage.length - 1; i >= 0; i--) {
          const k = localStorage.key(i);
          if (k && k.startsWith('syphrax_last_fetched_')) localStorage.removeItem(k);
        }
      } catch (_e) { /* ignore */ }
      clearVault().catch(() => {});
      setAuthToken(null);
      setBaseSession(null);
      setActiveSession(null);
    });
    return () => setOnUnauthorized(null);
  }, []);

  function handleLogout() {
    setAuthToken(null);
    setBaseSession(null);
    setActiveSession(null);
  }

  function handleAuthed(s: Session) {
    setBaseSession(s);
    setActiveSession(s);
  }

  // Switch entre sesiones (general ↔ pseudo-cuenta de freq).
  // - Al entrar en una freq: activeSession pasa a la pseudo, baseSession queda
  //   en memoria para volver. El JWT activo en api.ts es el de la pseudo.
  // - Al salir: activeSession vuelve a baseSession y reactivamos su JWT.
  function handleSwitchSession(s: Session) {
    setActiveSession(s);
  }

  if (!activeSession || !baseSession) {
    return <Auth onAuthed={handleAuthed} />;
  }
  return (
    <Chat key={activeSession.token}
      session={activeSession}
      baseSession={baseSession}
      onSwitchSession={handleSwitchSession}
      onLogout={handleLogout}
    />
  );
}
